// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1xZ5z","rootCenter":"LoadMoreObserver_rootCenter__2_SSj","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2lZy7"};